import { render, staticRenderFns } from "./CreateSlotDrawer.vue?vue&type=template&id=3a38094a&scoped=true"
import script from "./CreateSlotDrawer.vue?vue&type=script&lang=js"
export * from "./CreateSlotDrawer.vue?vue&type=script&lang=js"
import style0 from "./CreateSlotDrawer.vue?vue&type=style&index=0&id=3a38094a&prod&lang=scss&scoped=true"
import style1 from "./CreateSlotDrawer.vue?vue&type=style&index=1&id=3a38094a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38094a",
  null
  
)

export default component.exports